export default "__VITE_ASSET__BYOE1rHo__"